// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "v1.0-2025Jun10-796-g010e920e-dirty",
    "hash": "g010e920e",
    "distance": 796,
    "tag": "v1.0-2025Jun10",
    "semver": null,
    "suffix": "796-g010e920e-dirty",
    "semverString": "",
    "version": "0.0.1"
};
/* tslint:enable */
